var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLock = function SvgLock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.1 9.9V7.5c0-2.261-1.839-4.1-4.1-4.1S7.9 5.239 7.9 7.546V9.9H5.4v10.199h13.2v-10.2zm-7-2.4c0-1.6 1.301-2.9 2.9-2.9 1.6 0 2.9 1.302 2.9 2.947V9.9H9.1zm8.3 11.4H6.6v-7.801h10.8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 13h-1.5v4h1.5z"
  })));
};
export { SvgLock as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M16.1 9.9V7.5c0-2.261-1.839-4.1-4.1-4.1S7.9 5.239 7.9 7.546V9.9H5.4v10.199h13.2v-10.2zm-7-2.4c0-1.6 1.301-2.9 2.9-2.9 1.6 0 2.9 1.302 2.9 2.947V9.9H9.1zm8.3 11.4H6.6v-7.801h10.8z' clip-rule='evenodd'/%3e%3cpath fill='currentColor' d='M12.75 13h-1.5v4h1.5z'/%3e%3c/svg%3e";